import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { IdxAdjacentItems } from '../../_interfaces/icontrols-common/imenubar.interface';
import { IdxMenuItem } from '../../_interfaces/iprimeng/irefobject.interface';
import { MenuItem } from 'primeng/api';
import { DxControlUtilsService } from '../../_common/dx-control-utils.service';
import { Menubar } from 'primeng/menubar';
import { BaseComponent } from '../../_common/dx-base-component';

@Component({
    selector: 'dx-menubar',
    templateUrl: './menubar.component.html',
    styleUrls: ['./menubar.component.scss'],
    standalone: false
})
export class MenuBarComponent extends BaseComponent {
    @Input() menuItems!: IdxMenuItem[];
    @Input() adjacentItems!: IdxAdjacentItems[];
    @Input() listItems!: MenuItem[];
    @Input() badgeNotifEnable: boolean = false;

    @ViewChild("primMenuBar") primMenu!: Menubar;
    constructor(_globalSvc: DxControlUtilsService){
        super(_globalSvc);
    }
    
    override ngOnInit(): void {
        super.ngOnInit();
        this.componentName = 'MenuBarComponent';
        if(this.menuItems.length > 0){
            this.menuItems.map((item: IdxMenuItem) => {
                this._globalSvc.addComponent(item);
            });
        }
    }
    
    ngOnChanges(changes: SimpleChanges){
      let temp = this.primMenu;
    }

    isReloadItems: boolean = false;
    reloadItems(menuItems: any[], adjacentItems: any[]){
        this.menuItems = menuItems;
        this.adjacentItems = adjacentItems;
    }
}
